import { Controller } from "stimulus";

export default class extends Controller {
  static values = { token: String };

  connect() {
    this.pollingTimeout = null;
    this.startTime = Date.now();
    this.pollDuration = 5 * 60 * 1000;
    this.startPolling();
  }

  startPolling() {
    this.pollingTimeout = setTimeout(
      this.checkWebhookProcessed.bind(this),
      10000
    );
  }

  checkWebhookProcessed() {
    const params = new URLSearchParams({ token: this.tokenValue }).toString();
    fetch(`/check_webhook_status?${params}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.user_exists) {
          if (data.has_complete_data) {
            window.location.href = `/accounts/new?${params}`;
          } else {
            window.location.href = "/";
          }
        } else {
          const elapsedTime = Date.now() - this.startTime;

          if (elapsedTime >= this.pollDuration) {
            window.location.href = "/";
          } else {
            this.pollingTimeout = setTimeout(
              this.checkWebhookProcessed.bind(this),
              5000
            );
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching webhook status:", error);
        window.location.href = "/";
      });
  }

  disconnect() {
    if (this.pollingTimeout) {
      clearTimeout(this.pollingTimeout);
      this.pollingTimeout = null;
    }
  }
}
